import React from 'react';
import { motion } from 'framer-motion';
import { ScrollButton } from './Shared';
export const Hero = () => {
  return <section className="relative overflow-hidden" data-id="element-63">
      <div className="max-w-2xl mx-auto px-5 sm:px-6 lg:px-8 pt-8 pb-10 sm:pt-16 sm:pb-16" data-id="element-64">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-65">
          {/* Eyebrow */}
          <p className="text-brand-terracotta font-semibold text-xs sm:text-sm tracking-[0.2em] uppercase mb-5" data-id="element-66">
            PROFE LISTO · PILATES 360
          </p>

          {/* Headline */}
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-serif font-bold text-brand-charcoal leading-[1.05] mb-8 sm:mb-10" data-id="element-67">
            Todo tu año de Pilates resuelto de una vez.
          </h1>

          {/* Product Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.15
        }} className="mb-8 sm:mb-10" data-id="element-68">
            <img src="https://images.unsplash.com/photo-1518611012118-696072aa579a?auto=format&fit=crop&q=80&w=1200" alt="Megapack Pilates 360" className="w-full max-w-md mx-auto h-auto object-contain rounded-2xl shadow-xl" data-id="element-69" />
          </motion.div>

          {/* Description */}
          <p className="text-base sm:text-lg text-gray-600 leading-relaxed mb-7 sm:mb-8 max-w-md mx-auto" data-id="element-70">
            Megapack PILATES 360 — El sistema completo de sesiones y
            planificación para el profesor de Pilates argentino
          </p>

          {/* Pill Badges */}
          <div className="flex flex-wrap justify-center items-center gap-2 sm:gap-3 mb-8" data-id="element-71">
            <span className="bg-white border border-brand-sand shadow-sm rounded-full px-4 py-2 text-sm font-medium text-brand-charcoal whitespace-nowrap" data-id="element-72">
              📄 PDF
            </span>
            <span className="text-gray-300" data-id="element-73">|</span>
            <span className="bg-white border border-brand-sand shadow-sm rounded-full px-4 py-2 text-sm font-medium text-brand-charcoal whitespace-nowrap" data-id="element-74">
              ⚡ Acceso Inmediato
            </span>
            <span className="text-gray-300" data-id="element-75">|</span>
            <span className="bg-white border border-brand-sand shadow-sm rounded-full px-4 py-2 text-sm font-medium text-brand-charcoal whitespace-nowrap" data-id="element-76">
              📚 12 Tomos + 6 Bonus + 2 Élite
            </span>
          </div>

          {/* CTA */}
          <ScrollButton className="w-full bg-brand-terracotta hover:bg-brand-terracotta-dark text-white text-base sm:text-lg font-bold py-4 px-8 rounded-2xl shadow-lg shadow-brand-terracotta/30 transition-all transform hover:-translate-y-0.5 inline-flex items-center justify-center gap-2" data-id="element-77">
            💪 QUIERO MI PILATES 360 AHORA
          </ScrollButton>

          {/* Trust Line */}
          <div className="mt-5 flex flex-wrap justify-center items-center gap-x-3 gap-y-2 text-xs sm:text-sm text-gray-600" data-id="element-78">
            <span className="flex items-center gap-1.5" data-id="element-79">
              🛡️ Garantía 7 días
            </span>
            <span className="text-gray-300" data-id="element-80">|</span>
            <span className="flex items-center gap-1.5" data-id="element-81">🔒 Pago seguro</span>
            <span className="text-gray-300" data-id="element-82">|</span>
            <span className="flex items-center gap-1.5" data-id="element-83">
              💳 Tarjetas y transferencia
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
};